import { WarningOutlined } from '@ant-design/icons'
import { Select } from 'antd'
import { Tag, Tooltip } from '@surecompanies/core_components'
import React from 'react'
import { CensusFieldCatalogItem } from '../../api/company-ignore-api-client'
import styles from './CompanyIgnore.module.scss'

const { Option } = Select

const ELIGIBILITY_GUARD_MESSAGE =
  'This field can impact eligibility or pricing. Confirm eligibility-impacting fields before selecting it.'

interface FieldMultiSelectProps {
  fields: CensusFieldCatalogItem[]
  value: string[]
  loading: boolean
  disabled: boolean
  onChange: (fieldKeys: string[]) => void
}

export default function FieldMultiSelect({
  fields,
  value,
  loading,
  disabled,
  onChange,
}: FieldMultiSelectProps) {
  const handleChange = (nextValue: string[]) => {
    onChange(nextValue)
  }

  return (
    <div className={styles.fieldGroup}>
      <label className={styles.label}>Census Fields to Ignore changes</label>
      <Select
        mode="multiple"
        showSearch
        optionFilterProp="label"
        placeholder="Select census fields to ignore changes"
        value={value}
        loading={loading}
        disabled={disabled}
        onChange={handleChange}
        style={{ width: '100%' }}
        aria-label="Census Fields to Ignore Changes"
      >
        {fields.map((field) => {
          const label = field.isEligibilityImpacting ? (
            <Tooltip title={ELIGIBILITY_GUARD_MESSAGE}>
              <span className={`${styles.optionLabel} ${styles.guardedOption}`}>
                <WarningOutlined />
                {field.field}
                <Tag color="warning">Eligibility</Tag>
              </span>
            </Tooltip>
          ) : (
            field.field
          )

          return (
            <Option key={field.field} value={field.field} label={field.field}>
              {label}
            </Option>
          )
        })}
      </Select>
    </div>
  )
}
